export default __webpack_public_path__ + "static/media/cat_thoughtful.93828ec2.svg";